import styled from "styled-components";
import { connector_path_styles } from "./ConnectorPath.elements";

export const default_path_styles = `
  fill: transparent;
  stroke-width: 1.2;
 
  stroke-linecap: round;
  stroke-linejoin: round;

`

export const DefaultPath = styled.path`

  ${default_path_styles}

  &.is-filtered {
    //stroke: lightgray!important;
    opacity: 0!important;
    stroke-dasharray: 4 4!important;
  }
    
  &.connecting-line {
    ${connector_path_styles}
  }
`

export const PointLinePath = styled(DefaultPath)`
  stroke-width: 1.5;
`